import { f as o } from "./fails.js";
import { w as r } from "./well-known-symbol.js";
import { e as n } from "./engine-v8-version.js";
var e = r("species"),
  s = function s(r) {
    return n >= 51 || !o(function () {
      var o = [];
      return (o.constructor = {})[e] = function () {
        return {
          foo: 1
        };
      }, 1 !== o[r](Boolean).foo;
    });
  };
export { s as a };